import ROTYBadgeAnim from '../../uber-assets/roty-badge.json';
import Lottie from 'react-lottie';
import { PREV_WINNERS } from '../model/prev-winners';

export function PreviousWinnersSection({showPreviousWinners}) {
    return (
        <>
            <section className="previous-winners-section" id="prevWinners">
                <div className="section-container">
                    <div className='content'>
                        <div className="previous-winners-content">
                            {/* <h2>Who Stole the Show in 2023?</h2>
                            <p>See Sandwich Sandwich who took home the crown in the 2023 Restaurant of the Year Awards and discover the Pioneers & Innovators restaurants that truly stood out last year.</p>
                            <p>From innovative newcomers to established culinary titans, our winners list is a treasure trove for any foodie.</p> */}
                            <h1>Discover our 2024 Restaurant of the Year winner</h1>
                            <h1 className="roty-winner">{PREV_WINNERS.roty2024.name}</h1>
                            <button className="light big" onClick={() => window.open(PREV_WINNERS.roty2024.orderlink, "_blank")}>Order on Uber Eats</button>
{/*                         </div>
                    </div>
                </div>
            </section>

            <img src={'./img/2024-winners/winner2025_homepage.jpg'} alt="Restaurant of the Year 2024 Winner" className="roty-winner-image" />

            <section className="previous-winners-section">
                <div className="section-container">
                    <div className='content'>
                        <div className="previous-winners-content"> */}

                            <img src={'./img/2024-winners/winner2025_homepage.jpg'} alt="Restaurant of the Year 2024 Winner" className="roty-winner-image" />

                            <button className="light big" onClick={showPreviousWinners}>View all 2024 winners

                                        {/* <Lottie
                                            options={{
                                                loop: true,
                                                autoplay: true,
                                                animationData: ROTYBadgeAnim,
                                                rendererSettings: {
                                                    preserveAspectRatio: 'xMidYMid slice'
                                                }
                                            }}
                                            style={{
                                                width: 'auto',
                                                height: '80%',
                                                marginLeft: '1rem',
                                                zIndex: 1,
                                            }}
                                        /> */}

                            </button>
                        </div>
                    </div>
                </div>
            </section>
            {/* <div className="previous-winners-mob-image-container"></div> */}
        </>
    )
}